import { render } from "./AccountBox.vue?vue&type=template&id=c135444c"
import script from "./AccountBox.vue?vue&type=script&lang=js"
export * from "./AccountBox.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/AccountBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c135444c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c135444c', __exports__)) {
    api.reload('c135444c', __exports__)
  }
  
  module.hot.accept("./AccountBox.vue?vue&type=template&id=c135444c", () => {
    api.rerender('c135444c', render)
  })

}


export default __exports__